import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { get, post, put } from "../../../utils/api";
import InputField from "../../../Components/Masters/InputField";
import SelectField from "../../../Components/Masters/SelectField";
import FileField from "../../../Components/Masters/FileField";
import { validateNumber } from "../../../utils/validateFields";
import { numberError } from "../../../utils/validationMessage";
import Multiline from "../../../Components/Masters/Multiline";
import MultiSelect from "../../../Components/Common/MultiSelect";
import MonthYearPicker from "../../../Components/Common/MonthYearPicker";
import EditDialog from "../../../Components/Common/EditDialog";
import formatTitleWithOptional from "../../Scope1/OptionalFeild";
import { useUser } from "../../../context/AuthContext";

function AddConsumptionByFacility({
  inputData,
  fetchData,
  id,
  title,
  data,
  setAddData,
  SelectedData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const { user } = useUser();
  const [errors, setErrors] = useState({});
  const initialState = {
    consumptionPeriod: {
      month: SelectedData?.consumptionPeriod?.month || "",
      year: SelectedData?.consumptionPeriod?.year || "",
    },
    vendor: SelectedData?.vendor?._id || "",
    unitOfElectricityConsumption:
      SelectedData?.unitOfElectricityConsumption || "",
    previousMeterReading: SelectedData?.previousMeterReading || "",
    currentMeterReading: SelectedData?.currentMeterReading || "",
    equipment: SelectedData?.equipment?.map((item) => item._id),
    // hours: data.hours || "",
    // unit: data.unit || "",
    multiplicationFactor: SelectedData?.multiplicationFactor,
    reasonForDeviation: SelectedData?.reasonForDeviation || "",
    remarks: SelectedData?.remarks || "",
    editRemarkReason: SelectedData?.editRemarkReason || "",

    // documents: SelectedData?.documents || [],
  };
  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);
  const [equipmentOptions, setEquipmentOptions] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState("");
  const resetFrom = () => {
    setFormData(initialState);
    setFormData2(initialState);
    setErrors({}); // Reset errors
    setUploadedFiles(SelectedData !== null ? SelectedData?.documents : []);
  };

  useEffect(() => {
    if (SelectedData !== null) {
      setFormData(initialState);
      setFormData2(initialState);
      setUploadedFiles(SelectedData?.documents || []);
    } else {
      setFormData(initialState);
      setFormData2(initialState);

      setUploadedFiles([]);
    }
  }, [SelectedData]);

  useEffect(() => {
    let difference =
      parseFloat(formData.currentMeterReading) -
      parseFloat(formData.previousMeterReading);
    if (difference < 0.05) {
      setErrors({
        ...errors,
        currentMeterReading:
          "Current Meter Reading must be greater than Previous Meter Reading",
      });
    }
  }, [formData.currentMeterReading, formData.previousMeterReading]);

  useEffect(() => {
    let unitCount =
      formData.currentMeterReading - formData.previousMeterReading;

    if (unitCount > 0) {
      setFormData((prevData) => ({
        ...prevData,
        unitOfElectricityConsumption:
          unitCount * formData?.multiplicationFactor,
      }));
    }
  }, [
    formData.previousMeterReading,
    formData.currentMeterReading,
    formData.multiplicationFactor,
  ]);

  const handleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    } else {
      const { name, value } = e;
      setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };
  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    resetFrom();
    setSelectedMonth(data?.monthYear?.month || "");
    setSelectedYear(data?.monthYear?.year || "");
    // setFormData(initialState);
    // Reset form data to initial state
    setUploadedFiles(data?.documents || []); // Reset uploaded files
  };
  const handleClose = () => {
    // setAddData(false);
    // setErrors({});
    // resetFrom();
    const isFormDataUnchanged = Object.keys(formData).every((key) => {
      const value1 = formData[key];
      const value2 = formData2[key];
      if (
        typeof value1 === "object" &&
        value1 !== null &&
        typeof value2 === "object" &&
        value2 !== null
      ) {
        // For nested objects, do a deep comparison
        return JSON.stringify(value1) === JSON.stringify(value2);
      }

      // For primitive values or arrays, use strict equality
      return value1 === value2;
    });

    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);
    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree();
    } else {
      // setAddData(false);
      // setErrors({});
      setEditDialog(true);
      // resetForm();
      // Show the EditDialog if there are changes
    }
  };

  const validateForm = () => {
    const newErrors = {};

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "documents") return;
      // Check for calorificValue separately
      if (input.fieldName === "calorificValue") {
        const cvValue = formData[input.fieldName]?.value || ""; // Ensure it's a string
        const cvUnit = formData[input.fieldName]?.unit || ""; // Ensure it's a string

        if (!validateNumber(cvValue)) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Numeric Value required.",
          };
        }

        if (!cvUnit.trim()) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            unit: "Unit is required.",
          };
        }
        return; // Ensure to return after handling errors for calorificValue
      }

      if (input.fieldName === "quantityConsumed") {
        const Value = formData[input.fieldName]?.value || ""; // Ensure it's a string

        if (!validateNumber(Value)) {
          newErrors[input.fieldName] = numberError;
        }

        return; // Ensure to return after handling errors for calorificValue
      }

      if (input.fieldName === "consumptionPeriod") {
        if (month === "" || !validateNumber(month))
          newErrors["month"] = "Month is required";

        if (year === "" || !validateNumber(year))
          newErrors["year"] = "Year is required";

        return;
      }
      // Skip validation for hours and industrialEquipment if not in Individual mode
      if (
        formData.typeOfEntry !== "Individual" &&
        (input.fieldName === "hours" ||
          input.fieldName === "industrialEquipment")
      ) {
        return; // Skip validation for these fields
      }

      if (
        Number(formData?.currentMeterReading) <
        Number(formData?.previousMeterReading)
      ) {
        newErrors["currentMeterReading"] =
          "Current Meter Reading should be greater than Previous Meter Reading";
      }

      // Validation for numeric inputs
      if (input.type === "number" && input.required) {
        if (!validateNumber(value)) {
          newErrors[input.fieldName] = numberError;
          return; // Stop further checks for this input
        }
      }

      if (input.required && (!value || value === "")) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }
      // if (
      //   input.required &&
      //   input.fieldName === "equipment" &&
      //   (value?.length === 0 || value === undefined)
      // ) {
      //   newErrors[input.fieldName] = `${input.title} is required.`;
      // }

      const previousReading = parseFloat(formData.previousMeterReading);
      const currentReading = parseFloat(formData.currentMeterReading);

      const isPrevEmpty = formData.previousMeterReading === "";
      const isCurrEmpty = formData.currentMeterReading === "";

      if (isPrevEmpty && isCurrEmpty) {
        newErrors.currentMeterReading = "Please enter a valid numeric value.";
      } else if (!isNaN(currentReading) && !isNaN(previousReading)) {
        if (currentReading <= previousReading) {
          newErrors.currentMeterReading =
            "Current Meter Reading must be greater than Previous Meter Reading";
        }
      } else {
        newErrors.currentMeterReading = "Please enter a valid numeric value.";
      }

      // Additional checks for required fields
      if (
        input.required &&
        input.type !== "number" &&
        input.type !== "multiselect" &&
        (!value || value.trim() === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }

      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchEquipmentOptions = async () => {
    try {
      const response = await get(`/master/Electricity/getEquipment`);
      setEquipmentOptions(response.data.data);
    } catch (error) {
      console.error("Error fetching equipment options:", error);
    }
  };

  useEffect(() => {
    fetchEquipmentOptions();
  }, []);

  const Save = async () => {
    if (!validateForm()) return;
    // Prepare data to send, including only fields with values
    const dataToSend = {
      ...formData,
      documents: uploadedFiles,
    };
    // Conditionally delete fields if typeOfEntry is not "Individual"
    if (formData.typeOfEntry !== "Individual") {
      delete dataToSend.hours;
      delete dataToSend.industrialEquipment;
    }

    // Remove fields that have empty values
    // Object.keys(dataToSend).forEach((key) => {
    //   if (
    //     dataToSend[key] === "" || // Empty strings
    //     (typeof dataToSend[key] === "object" &&
    //       Object.keys(dataToSend[key]).length === 0) // Empty objects
    //   ) {
    //     delete dataToSend[key];
    //   }
    // });
    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }

    const url = SelectedData?._id
      ? `${updateUrl}?Id=${SelectedData?._id}`
      : `${addUrl}`;

    const method = SelectedData?._id ? put : post;
    try {
      const res = await method(url, dataToSend);
      setsnackOpen({
        open: true,
        message: res.data.message,
        severity: "success",
      });
      fetchData();
      setFormData(initialState);
      setUploadedFiles([]);
      handleExitAgree();
      // handleClose();
      resetFrom();
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        const errorMessages = err.response.data.errors
          .map((error) => error.msg)
          .join(", ");
        setsnackOpen({
          open: true,
          message: errorMessages,
          severity: "error",
        });
      }
    }
  };

  const renderInputField = (el) => {
    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 2 }}>
          <MonthYearPicker
            title={"Consumption Month"}
            {...{
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
              // defaultMonth: formData?.consumptionPeriod?.month || "",
              // defaultYear: formData?.consumptionPeriod?.year || "",
            }}
          />
        </Box>
      );
    }
    if (el.options || el.type === "select") {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          errors={errors[el.fieldName]}
          url={el.url}
          field={el.field}
        />
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    if (el.fieldName === "remarks")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );
    if (el.fieldName === "reasonForDeviation")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    if (el.type === "multiselect") {
      return (
        <MultiSelect
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          label="Choose Options"
          onChange={handleChange}
          errors={errors[el.fieldName]}
          url={el?.url}
          // field={el.field}
        />
      );
    }
    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null;
    }

    return (
      <InputField
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={
          el.fieldName === "quantityConsumed"
            ? formData[el.fieldName]?.value
            : formData[el.fieldName] || ""
        }
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
        adornmentText={el.fieldName === "unitOfElectricityConsumption" && "KWH"} // Pass error prop
        disabled={["unitOfElectricityConsumption"].includes(el.fieldName)}
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "400px", maxWidth: "100%" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {SelectedData?._id
            ? `Edit Consumption By Facility`
            : `Add Consumption By Facility`}
          {/* AddData */}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment
          if (
            (el.fieldName === "hours" ||
              el.fieldName === "industrialEquipment") &&
            formData.typeOfEntry !== "Individual"
          ) {
            return null; // Skip rendering these fields if typeOfEntry is not "Individual"
          }

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default AddConsumptionByFacility;
